import {FormControl, FormGroup} from '@angular/forms';
import {Injectable} from '@angular/core';

@Injectable()
export class ValidatorService {

  public validate(form: FormGroup) {
    Object.keys(form.controls).forEach(field => {
      const control = form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validate(control);
      }
    });
  }

  public validateControl(formControl: FormControl) {
    formControl.markAsTouched({onlySelf: true});
  }

  public isValid(form: FormGroup): boolean {
    return form.valid;
  }

  public isValidFormGroup(form: FormGroup): boolean {
    this.validate(form);
    return this.isValid(form);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/validator/validator.service.ts